import { render, staticRenderFns } from "./LoanAuthorization.vue?vue&type=template&id=3b0ef790"
import script from "./LoanAuthorization.vue?vue&type=script&lang=js"
export * from "./LoanAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports